"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var url_helpers_1 = require("../components/shared/url_helpers");
var billing_method_1 = require("./billing_method");
var wrapped_location_1 = require("../lib/wrapped_location");
function onBillingMethodUpdateComplete() {
    var url = url_helpers_1.default.mySellingStatementsPath({ invoice_success: true });
    // need a full page refresh to flush rails view data on the statements page
    wrapped_location_1.default.assign(url);
}
function StatementBillingMethod() {
    return (React.createElement(billing_method_1.default, { onUpdateBillingMethodSuccess: onBillingMethodUpdateComplete, returnURL: url_helpers_1.default.mySellingStatementsPath(), showEditURL: true }));
}
exports.default = StatementBillingMethod;
//# sourceMappingURL=statement_billing_method.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/billing/statement_billing_method.js
// module id = mDG9
// module chunks = 20 21